import GenericRequest, { METHOD_DELETE } from '../../shared/webservices/GenericRequest';
import RouterUtils from '../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export class ContractorsDeleteRequest extends GenericRequest {

    request;

    constructor(id) {
        super(METHOD_DELETE, RouterUtils.generateRoute(ApiEndpoints.CONTRACTORS_DELETE, { id }));
        this.request = {};
    }

    overrideRequest() {
        return this.request;
    }

}



// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsDeleteRequest.js